<template>
  <div class="container">
  <div class="seckill-content" :style="{ padding: floor.$padding, backgroundImage: `url(${floor.bgImageUrl})`}"> 
    <div class="header" v-if="floor.hideInfo === 2">
      <div class="left">
        <img class="image" src="@/assets/home/kill-title.png" mode="aspectFill" />
        <div v-if="showCountDown" >
          <span class="count">{{timeData.hours}}</span>
          <span class="split">:</span>
          <span class="count">{{timeData.minutes}}</span>
          <span class="split">:</span>
          <span class="count">{{timeData.seconds}}</span>
        </div>   
      </div>
      <div class="right">
        <div ref="scrollView" class="scroll-view">
          <div 
            :class="['item', index === timeIndex ? 'active' : '']"
            v-for="(item, index) of floor.seckillActivityList"
            :key="index"
            @click="updateGoodsList(index)">
            <div class="view time">{{item.title}}</div>
            <div class="view desc">{{item.statusDesc}}</div>
          </div>
        </div>
        <img
          class="arrow"
          src="@/assets/image/arrow_icon@2x.png"
          @click="onNavigateTo"
        />
      </div>
    </div>
    <scroll-bar ref="scrollBar" style="background-color: #ffffff">
      <div :class="['goods-box', floor.$rowClass]">
        <div 
          class="goods"
          v-for="(item, index) of floor.goodsList"
          :key="index"
          @click="$emit('jump', { item, index })"
        >
          <div class="left">
            <img class="image" :src="item.indexImageUrl" />
            <img class="image photo" v-if="item.photoFrameUrl" :src="item.photoFrameUrl"  />
          </div>
          <div class="right">
            <div v-if="floor.goodsList.length > 1" class="progress">
              <van-progress 
                :percentage="item.percent" 
                :show-pivot="false"
                :stroke-width="rem2px(6)" 
                :border-radius="rem2px(6)" 
                color="#ed3939"
              />
            </div>
            <div class="goods-name">{{item.goodsName}}</div>
            <div class="sell-prop">{{item.sellProp}}</div>
            <div class="progress-box" v-if="floor.goodsList.length == 1">
              <van-progress 
                :percentage="item.percent" 
                :show-pivot="false"
                :stroke-width="rem2px(12)" 
                :border-radius="rem2px(6)" 
                color="#ed3939" />
              <span class="text">{{item.progress}}%</span>
            </div>
            <div class="price">
              <div class="goods-price">
                <span class="name" v-if="floor.goodsList.length === 1">秒杀价：</span>
                <span class="symbol">￥</span>{{item.goodsPrice}}
              </div>
              <!-- <div class="market-price" v-if="item.markingPrice">￥{{item.markingPrice}}</div> -->
              <div class="market-price" v-if="item.markingPrice && item.markingPrice > item.goodsPrice">￥{{item.markingPrice}}</div>
              <img class="rob" src="@/assets/home/rob.png" />
              <span v-if="floor.goodsList.length == 1" class="now-rob">马上抢</span>
            </div>
          </div>
        </div>
      </div>
    </scroll-bar>
    </div>
  </div>
</template>

<script>
import utils from '@/utils/common'
import http from "@/utils/axios";
import { navigateTo } from '@/views/activities/utils'
import ScrollBar from '../../components/scroll-bar'
export default {
  components: { ScrollBar },
  props: {
    floor: Object,
    home: Object
  },
  data() {
    return {
      time: 0,
      timeData: {},
      timeIndex: 0,
      scrollLeft: 0,
      showCountDown: false
    }
  },
  created() {
    this.init()
  },
  methods: {
    rem2px: utils.rem2px,
    /**
     * 使用this.$set会触发watch
     * 所以用if(this.unwatch) this.unwatch() 和
     * this.unwatch = this.$watch('floor', this.init)
     * 包裹代码保证每次执行只触发一次
     */
    init() {
      if(this.unwatch) this.unwatch();
      const bar = this.$refs.scrollBar
      bar && bar.updateThumbWidth()
      this.normalizeFloor()
      this.setTime()
      this.unwatch = this.$watch('floor', this.init)
    },
    normalizeFloor(list) {
      const { floor, home } = this
      Object.assign(floor, home.seckillComponent)
      floor.goodsList = list || floor.seckillActivityGoodsList
      floor.goodsList.forEach(item => {
        this.$set(item, 'photoFrameUrl', item.cornerMark && item.cornerMark.photoFrameImageUrl)
        this.normalizeProgress(item)
      })
      this.makeRow(floor)
      this.updateBgImageUrl()
    },
    normalizeProgress(item) {
      let scale = ((item.totalStock - item.currentStock) / item.totalStock) * 100
      scale = isNaN(scale) ? 0 : scale
      this.$set(item, 'percent', scale.toFixed(2))
      this.$set(item, 'progress', scale.toFixed(0))
    },
    makeRow(floor) {
      const len = floor.goodsList.length
      const rows = {
        1: 'row-one',
        2: 'row-two',
        3: 'row-three'
      }
      floor.$rowClass = rows[len >= 3 ? 3 : len]
    },
    updateBgImageUrl() {
      const { floor } = this
      const len = floor.goodsList.length
      const url = len > 1 ? floor.baseImage2Url : floor.baseImageUrl
      this.$set(floor, 'bgImageUrl', url)
    },
    setTime() {
      this.$nextTick(() => {
        if(!this.$refs.scrollView) return;
        const { floor } = this
        const index = Math.max(floor.seckillActivityList.findIndex(item => item.isSelect === 1), 0)
        const oneHundredHours = 60 * 60 * 100 * 1000 // 一百小时
        const item = this.floor.seckillActivityList[index]
        const time = item.nextStartMillisecond
        this.timeIndex = index
        this.$refs.scrollView.scrollLeft = this.computeScrollLeft(index)
        this.showCountDown = floor.showCountDown === 1 && time < oneHundredHours
        if(this.showCountDown) {
          this.startedCountDown(time)
        }
      })
    },
    startedCountDown(time) {
      clearInterval(this.timer);
      time = time / 1000
      const addZero = n => n < 10 ? '0' + n : n;
      const run = (s) => {
        if(!s) {
          clearInterval(this.timer)
          this.showCountDown = false
          return
        }
        this.timeData = {
         hours: addZero(Math.floor(s / (60 * 60))),
         minutes: addZero(Math.floor(s % (60 * 60) / 60)),
         seconds: addZero(Math.floor(s % 60))
       }
      }
      this.timer = setInterval(() => run(--time), 1000)
      run(time)
    },
    updateGoodsList(index) {
      const { floor } = this
      const item = floor.seckillActivityList[index]
      http({
        url: '/order/app/seckill/getGoodsList',
        method: 'POST',
        parmes: {
          startTime: item.startTime,
          endTime: item.endTime
        }
      }).then(data => {
        if(data.code === 200 && (data = data.data)) {
          this.normalizeFloor(data)
          this.timeIndex = index
          this.scrollLeft = this.computeScrollLeft(index)
          this.$refs.scrollBar.updateThumbWidth()
        }
      })
    },
    computeScrollLeft(index) {
      if(index) {
        const itemWidth = 94
        return (index - 1) * utils.rem2px(itemWidth, false)
      }
      return 0
    },
    onNavigateTo() {
      const { floor } = this
      const url = floor.seckillLinkUrl
      if(url) {
        navigateTo(this, {
          pageLinkType: 2,
          pageLinkValue: url
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import url('./style-one.less');
</style>
